import api from './api';

export type RembgStatus = {
  running: boolean;
  total: number;
  done: number;
  started_at?: string;
  finished_at?: string | null;
};

export const getRembgStatus = async (): Promise<RembgStatus> => {
  const res = await api.get('/rembg/status', { timeout: 20000 });
  return res.data;
};

export const startRembgBatch = async (): Promise<{ started: boolean; status: RembgStatus }> => {
  const res = await api.post('/rembg/start', null, { timeout: 20000 });
  return res.data;
};
